import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import Pill from './Pill/Pill.jsx';
import * as constants from '../../constants/constants';
// TODO: Use move to another line by CSS instead simplySlider or pes slider

class _Pills extends Component {
  constructor(props) {
    super(props);
  }

  setClassName = (selectedPill, curType) => `btn btn-light btn-rounded cart-pills__item ${selectedPill === curType ? 'selected' : ''}`;

  mapTypeToLabel = (type, labelsStore) => {
    const labelName = constants.pillsNamePrefix + constants.groupLabelMap[type];
 
    if (labelName in labelsStore && labelsStore[labelName]) {
      return labelsStore[labelName];
    }

    return type;
  };

  render() {
    const { cardsType, selectedPill, labelsStore } = this.props;

    return (
      <div className="cart-pills__wrapper">
        <ul className="cart-pills" ref={this.myRef}>
          {Object.keys(cardsType).map((type) => (
            <Pill
              key={type}
              type={type}
              classNames={this.setClassName(selectedPill, type)}
              label={this.mapTypeToLabel(type, labelsStore)}
            />
          ))}
        </ul>
      </div>
    );
  }
}

_Pills.propTypes = {
  selectedPill: propTypes.string.isRequired,
  labelsStore: propTypes.object.isRequired,
  cardsType: propTypes.object.isRequired
};

export default inject((allStores) => ({
  labelsStore: allStores.labelsStore,
  selectedPill: allStores.uiStore.type,
  cardsType: allStores.uiStore.cardsType
}))(observer(_Pills));
